import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  NOTIFICATION_MESSAGE_ERROR,
  NOTIFICATION_MESSAGE_INFO,
  NOTIFICATION_MESSAGE_SUCCESS,
  NOTIFICATION_MESSAGE_WARNING,
  NotificationMessage
} from '../../../models/notification-message.model';
import { NotificationMessagesService } from '../../../services/notification-messages.service';

@Component({
  selector: 'app-notification-messages',
  templateUrl: './notification-messages.component.html',
  styleUrls: ['./notification-messages.component.css']
})
export class NotificationMessagesComponent implements OnInit, OnDestroy {
  messages: NotificationMessage[] = [];
  private messageSubscription: Subscription;

  public readonly NOTIFICATION_MESSAGE_INFO = NOTIFICATION_MESSAGE_INFO;
  public readonly NOTIFICATION_MESSAGE_SUCCESS = NOTIFICATION_MESSAGE_SUCCESS;
  public readonly NOTIFICATION_MESSAGE_WARNING = NOTIFICATION_MESSAGE_WARNING;
  public readonly NOTIFICATION_MESSAGE_ERROR = NOTIFICATION_MESSAGE_ERROR;

  constructor(
    private notificationMessagesService: NotificationMessagesService
  ) { }

  ngOnInit(): void {
    this.messageSubscription = this.notificationMessagesService.messages$.subscribe(message => {
      if (message === null) {
        this.messages = [];
      } else if (message) {
        this.messages.push(message);
      }
    });
  }

  ngOnDestroy(): void {
    // Es crucial desuscribirse para evitar fugas de memoria
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }

  /**
   * Adds a new message to the list.
   *
   * @param {string} messageText - The text content of the message to be added.
   * @param {NotificationMessageType} [messageType=NOTIFICATION_MESSAGE_SUCCESS] - The type of the message, defaults is success.
   * @return {void} This method does not return a value.
   */
  /*
  addMessage(messageText: string, messageType: NotificationMessageType = NOTIFICATION_MESSAGE_INFO): void {
    this.messages.push({ text: messageText, type: messageType });
  }
  */

  /**
   * Removes a specified message from the list.
   *
   * @param {NotificationMessage} message - The message to be removed from the list.
   * @return {void} This method does not return a value.
   */
  removeMessage(message: NotificationMessage): void {
    this.messages = this.messages.filter(m => m !== message);
  }

}
